import {
  DocumentsWrapper,
  DocList,
  DocItem,
  AddDocWrapper,
  AddDocInput,
  AddDocBtn,
  DocItemWrapper,
  RemoveItemBtn,
} from './styles';

import useForm from '../../hooks/useForm';
import ValidationInput from '../ValidationInput';

const DocumentsEdit = ({ documents, setEditedDataField }) => {
  const { formValues, handleChange, setValues } = useForm({
    initialValues: {
      addDocInput: '',
    },
  });

  const addDoc = () => {
    if (formValues.addDocInput.length <= 0 || formValues.addDocInput.length > 1020) {
      return;
    }
    let currentData = [...documents];
    currentData.push(formValues.addDocInput);
    setEditedDataField('documents', currentData);
    setValues({ addDocInput: '' });
  };

  return (
    <DocumentsWrapper>
      <DocList>
        {documents.map((doc, index) => (
          <DocItemWrapper key={index}>
            <DocItem key={index}>{doc}</DocItem>
            <RemoveItemBtn
              onClick={() => {
                let modifiedData = [...documents];
                modifiedData.splice(index, 1);
                setEditedDataField('documents', modifiedData);
              }}
            />
          </DocItemWrapper>
        ))}
      </DocList>
      <AddDocWrapper>
        <ValidationInput
          component={AddDocInput}
          containerStyle={{ width: '100%' }}
          placeholder='Document...'
          value={formValues.addDocInput}
          onChange={handleChange}
          name='addDocInput'
          validation={(value) => value.length < 200}
          errorMsg={'Document is too long, max characters allowed: 200'}
          type='text'
        />
        <AddDocBtn
          title={'add document'}
          onClick={addDoc}
          disabled={formValues.addDocInput.length > 200}
        />
      </AddDocWrapper>
    </DocumentsWrapper>
  );
};

export default DocumentsEdit;
